import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { AdvertisingDeleteUseCaseInterface } from 'domain/usecases';

export class RemoteAdvertisingDelete
  implements AdvertisingDeleteUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: AdvertisingDeleteUseCaseInterface.Params,
  ): Promise<AdvertisingDeleteUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url:
        this.url +
        `/${params.organizationHashId}/advertisement/${params.advertisementID}`,
      method: 'delete',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
